import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { apiGet } from "../client";
import type { Page, Post } from "../types";
import type { FeedTab } from "./qk";
import { qk } from "./qk";

export type { FeedTab };

export const feedInfiniteQuery = (tab: FeedTab) =>
  infiniteQueryOptions({
    queryKey: qk.feed(tab),
    queryFn: ({ pageParam }: { pageParam: string | null }) =>
      apiGet<Page<Post>>(`/api/feed?tab=${tab}&limit=20${pageParam ? `&cursor=${pageParam}` : ""}`),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage: Page<Post>) => lastPage.nextCursor,
    staleTime: 60_000, // plan §5: feed
  });

export const trendingQuery = () =>
  queryOptions({
    queryKey: qk.trending(),
    queryFn: () => apiGet<{ tags: { tag: string; posts: number }[] }>("/api/trending"),
    staleTime: 120_000, // catalog-ish, changes infrequently
  });
